export const triggerEmarsysReload = (): void => {
    if (globalThis.ScarabUtil?.loadedModules?.emarsys_webpersonalization?.instance) {
        globalThis.ScarabUtil.loadedModules.emarsys_webpersonalization.instance.reload();
    }
};
